import type React from 'react';
import { useEffect, useRef, useState } from 'react';

interface Props {
    children: React.ReactNode;
    visibilityTimeMs?: number;
    onClose?: () => void;
}

const FIVE_SECONDS = 5000;

export const AutoClose: React.FC<Props> = ({ children, visibilityTimeMs = FIVE_SECONDS, onClose }) => {
    const [visible, setVisible] = useState(true);
    // these refs are necessary for final quiz to properly auto close questions skipped alert banner
    // because of timer tick was resetting onClose callback
    const onCloseRef = useRef(onClose);
    const timerRef = useRef<number | null>(null);

    useEffect(() => {
        onCloseRef.current = onClose;
    }, [onClose]);

    useEffect(() => {
        timerRef.current = window.setTimeout(() => {
            setVisible(false);
            onCloseRef.current?.();
        }, visibilityTimeMs);

        return () => {
            if (timerRef.current) {
                window.clearTimeout(timerRef.current);
                timerRef.current = null;
            }
        };
    }, [visibilityTimeMs]);

    return visible ? children : null;
};
